/*
 * Zimma product carousel — prev/next arrows for the horizontal scroll track.
 * Arrows only show on desktop and only when the track actually overflows.
 */
(function () {
  function initSection(section) {
    section.querySelectorAll('[data-zimma-carousel-track]').forEach(function (track) {
      var nav = section.querySelector('[data-zimma-carousel-nav]');
      if (!nav) return;

      var prev = nav.querySelector('[data-dir="prev"]');
      var next = nav.querySelector('[data-dir="next"]');

      function maxScroll() {
        return track.scrollWidth - track.clientWidth;
      }

      function update() {
        if (maxScroll() <= 4) {
          nav.hidden = true;
          return;
        }
        nav.hidden = false;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll() - 2;
      }

      function step() {
        var card = track.querySelector('.zimma-carousel__item');
        var w = card ? card.getBoundingClientRect().width + 18 : track.clientWidth * 0.8;
        return w * 2;
      }

      nav.querySelectorAll('.zimma-carousel__arrow').forEach(function (btn) {
        btn.addEventListener('click', function () {
          track.scrollBy({
            left: btn.dataset.dir === 'next' ? step() : -step(),
            behavior: 'smooth'
          });
        });
      });

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.zimma-carousel-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
